import type { Dispatch, SetStateAction } from "react";

import type { Call } from "@/types/call.types";
import type { AppointmentStatusUpdatePayload } from "@/types/call.types";
import type { IncidentReviewingNotificationPayload } from "@/types/incident.types";

import { createAppointmentNotificationAdapter } from "./appointment-notification.adapter";
import { NotificationAdapterFactory } from "./base/notification-adapter-factory";
import { createCallNotificationAdapter } from "./call-notification.adapter";
import { createIncidentNotificationAdapter } from "./incident-notification.adapter";

export const createElitphoneNotificationAdapterFactory = ({
    handleCallNotification,
    handleAppointmentStatusUpdate,
    handleAppointmentRemoval,
    handleIncidentReviewingNotification,
    setPendingRecordId,
}: {
    handleCallNotification: (call: Call) => void;
    handleAppointmentStatusUpdate: (
        notification: AppointmentStatusUpdatePayload,
        onDetailsClick: (leadId: string) => void
    ) => void;
    handleAppointmentRemoval: (appointmentId: string) => void;
    handleIncidentReviewingNotification: (notification: IncidentReviewingNotificationPayload) => void;
    setPendingRecordId: Dispatch<SetStateAction<string | null>>;
}): NotificationAdapterFactory => {
    const callAdapter = createCallNotificationAdapter(handleCallNotification);
    const appointmentAdapter = createAppointmentNotificationAdapter({
        handleAppointmentStatusUpdate,
        handleAppointmentRemoval,
        setPendingRecordId,
    });
    const incidentAdapter = createIncidentNotificationAdapter({ handleIncidentReviewingNotification });

    return new NotificationAdapterFactory([callAdapter, appointmentAdapter, incidentAdapter]);
};
